import 'core-js/modules/es.object.assign.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useUtility, useIsMobile, Stack, Button, Text, Box, AssistChip } from '@hub-la/design-system';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import Circle from '@mui/icons-material/Circle';
import { Avatar, CircularProgress } from '@mui/material';
import moment from 'moment';
import { Fragment as Fragment$1 } from 'react';
import { useTranslation } from 'react-i18next';
import img from '../../assets/default-user-avatar.js';
import { useGetCommentReplies } from '../../hooks/use-get-replies.js';
import { Comment } from './comment.js';

const CommentReplies = ({
  count,
  latestReplyAt,
  commentId,
  hasOwnerReply,
  discussionOwner,
  toggleReplies,
  setToggleReplies
}) => {
  var _a, _b;
  const {
    t
  } = useTranslation();
  const {
    palette
  } = useUtility();
  const isMobile = useIsMobile();
  const {
    data: repliesData,
    fetchNextPage,
    isFetching,
    isLoading,
    hasNextPage,
    isFetchingNextPage
  } = useGetCommentReplies({
    commentId,
    enabled: toggleReplies,
    pageSize: isMobile ? 2 : 5
  });
  const lastReplyFormated = moment(latestReplyAt).locale('pt-br').fromNow();
  const handleOpenReplies = () => {
    setToggleReplies(!toggleReplies);
  };
  return jsxs(Fragment, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      alignItems: "center",
      mb: 3,
      gap: 1
    }, {
      children: [jsx(Button, Object.assign({
        iconOnly: true,
        variant: "text",
        size: "small",
        onClick: handleOpenReplies
      }, {
        children: toggleReplies ? jsx(ArrowDropUp, {
          style: {
            color: 'white'
          }
        }) : jsx(ArrowDropDown, {
          style: {
            color: 'white'
          }
        })
      })), jsxs(Stack, Object.assign({
        direction: "row",
        alignItems: "center",
        gap: 2
      }, {
        children: [hasOwnerReply && jsx(Avatar, {
          src: (_a = discussionOwner === null || discussionOwner === void 0 ? void 0 : discussionOwner.picture) !== null && _a !== void 0 ? _a : String(img),
          sx: {
            width: 24,
            height: 24
          },
          "data-testid": "avatar"
        }), jsx(Circle, {
          sx: {
            width: 5,
            height: 5
          }
        }), jsxs(Text, Object.assign({
          variant: "caption"
        }, {
          children: [" ", t('comment.replies.count', {
            count
          })]
        })), !isMobile && jsx(Text, Object.assign({
          variant: "caption",
          color: "neutralPrimary"
        }, {
          children: t('comment.replies.lastAnswer', {
            date: lastReplyFormated
          })
        }))]
      }))]
    })), toggleReplies && jsx(Box, Object.assign({
      borderLeft: 1,
      borderColor: isLoading ? 'transparent' : palette('surfaceVariant'),
      marginLeft: 3.9,
      paddingLeft: 5
    }, {
      children: jsxs(Stack, Object.assign({
        gap: 3
      }, {
        children: [((_b = repliesData === null || repliesData === void 0 ? void 0 : repliesData.pages) !== null && _b !== void 0 ? _b : []).map((group, i) => {
          var _a;
          return jsx(Fragment$1, {
            children: (_a = group === null || group === void 0 ? void 0 : group.items) === null || _a === void 0 ? void 0 : _a.map(replyComment => {
              var _a, _b;
              return jsx(Comment, {
                commentId: replyComment.id,
                parentCommentId: commentId,
                comment: replyComment.message,
                fullName: (_a = replyComment === null || replyComment === void 0 ? void 0 : replyComment.user) === null || _a === void 0 ? void 0 : _a.name,
                avatarUrl: (_b = replyComment === null || replyComment === void 0 ? void 0 : replyComment.user) === null || _b === void 0 ? void 0 : _b.picture,
                createdAt: replyComment.createdAt,
                likes: replyComment.likesCount,
                avatarSize: 24,
                isReply: true,
                isEdited: replyComment.wasEdited,
                userId: replyComment === null || replyComment === void 0 ? void 0 : replyComment.userId
              }, replyComment.id);
            })
          }, i);
        }), isFetching && jsx(Stack, Object.assign({
          direction: "row",
          justifyContent: "center",
          width: "100%",
          color: "#fff"
        }, {
          children: jsx(CircularProgress, {
            color: "inherit"
          })
        })), hasNextPage && jsx(AssistChip, {
          variant: "outlined",
          label: "Ver mais respostas",
          onClick: () => fetchNextPage(),
          disabled: isFetchingNextPage
        })]
      }))
    }))]
  });
};

export { CommentReplies };
